<template>
  <el-card class="h-full flow-list" :body-style="{ height: '100%', overflow: 'auto' }">
    <el-tabs v-model="activeTab" @tab-click="tabClick" class="h-full">
      <el-tab-pane
        :label="`${item.label}(${item.name === 'todo' ? todoNum : doneNum})`"
        :name="item.name"
        class="h-full"
        v-for="item in tabList"
        :key="item.name"
      >
        <div>
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item>
              <el-input
                size="small"
                clearable
                placeholder="标题"
                class="!w-200px"
                v-model="formInline.title"
                maxlength="50"
              />
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="searchList">搜索</el-button>
              <el-button size="small" @click="reset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table
          height="calc(100% - 110px)"
          :data="tableData"
          v-loading="tableLoading"
          ref="table"
          border
        >
          <el-table-column type="index" align="center" label="序号" width="50" />
          <el-table-column label="标题">
            <template slot-scope="scope">
              <div
                class="text-hex-$portalPrimaryColor cursor-pointer"
                @click="clickTitle(scope.row)"
              >
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :label="item.label"
            :width="item.width"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div>
                {{ item.flowField ? scope.row.flowInfo[item.prop] : scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <el-button size="mini" @click="toDetail(scope.row, 'read')">查看</el-button>
              <el-button
                size="mini"
                @click="toDetail(scope.row, scope.row.workflowStatus === 1 ? 'approve' : 'submit')"
                v-if="activeTab === 'todo'"
                >处理</el-button
              >
              <el-button size="mini" @click="handleProcess(scope.row)">查看流程</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="text-right mt-20px"
          background
          @size-change="searchList()"
          @current-change="findList()"
          :current-page.sync="page.pageNo"
          :page-size.sync="page.pageSize"
          :total="page.pageTotal"
          layout="sizes, total, prev, pager, next, jumper"
          :pager-count="5"
          :page-sizes="[15, 30, 45, 60, 75, 90]"
        >
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <previewDialog
      ref="previewDialog"
      :visible.sync="previewDialogVisible"
      :data="previewData"
    ></previewDialog>
    <viewFlow :visible.sync="flowVisible" :id="flowTaskId" />
  </el-card>
</template>

<script>
import { ColumnTableSearchApi, ColumnTableApi } from '@wiz-api/workbench'
import dayjs from 'dayjs'
import { informationPublishMap } from '../../js/config'

const previewDialog = () => {
  return import('../information-publish/ColumnPublishManagement/PreviewDialog')
}
const viewFlow = () => {
  return import('@/components/ViewFlow')
}
const columnTableSearchApi = new ColumnTableSearchApi()
const columnTableApi = new ColumnTableApi()
const columnTypes = informationPublishMap.column
const columnTextType = columnTypes.columnText // 文字栏目
const columnImgTextType = columnTypes.columnImgText // 图文栏目
const columnVideoType = columnTypes.columnVideo // 视频栏目
export default {
  components: {
    previewDialog,
    viewFlow,
  },
  data() {
    return {
      activeTab: 'todo',
      tabList: [
        {
          name: 'todo',
          label: '待办',
        },
        {
          name: 'done',
          label: '已办',
        },
      ],
      formInline: {
        title: '',
      },
      tableData: [],
      tableLoading: false,
      columnList: [
        {
          label: '栏目',
          prop: 'columnName',
          width: '',
        },
        {
          label: '发起人',
          prop: 'creatorName',
          width: '100',
        },
        {
          label: '节点名称',
          prop: 'stepName',
          width: '',
          flowField: true,
        },
        {
          label: '发起时间',
          prop: 'creationTime',
          width: '',
        },
        {
          label: '接收时间',
          prop: 'receiveTime',
          width: '',
          flowField: true,
        },
      ],
      page: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      todoList: [],
      todoNum: 0,
      doneList: [],
      doneNum: 0,
      previewDialogVisible: false,
      previewData: {
        isShowSidebar: false,
        title: '',
        textAuthor: '',
        videoAuthor: '',
        editpublishTime: '',
        content: '',
        attachFile: '',
        type: '',
      },
      flowVisible: false,
      flowTaskId: 0,
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  watch: {
    '$route.query.activeTab': {
      immediate: true,
      handler(val) {
        if (val) {
          this.activeTab = this.$route.query.activeTab
        }
      },
    },
  },
  methods: {
    searchList() {
      this.page.pageNo = 1
      this.findList()
    },
    async findList() {
      this.tableLoading = true
      if (this.activeTab === 'todo') {
        await this.getTodoList()
        this.tableData = this.todoList
        this.page.pageTotal = this.todoNum
      } else {
        await this.getDoneList()
        this.tableData = this.doneList
        this.page.pageTotal = this.doneNum
      }
      this.tableLoading = false
    },
    async getAll() {
      this.tableLoading = true
      await this.getTodoList()
      await this.getDoneList()
      this.tabClick()
      this.tableLoading = false
    },
    async getTodoList() {
      const [err, res] = await columnTableSearchApi.getTodoColumnTableV(
        this.page.pageNo,
        this.page.pageSize,
        {
          title: this.formInline.title,
          isCompeleted: false,
        }
      )
      if (!err) {
        this.todoList = _.map(res.items, (item) => {
          item.creationTime = item.creationTime
            ? dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
          item.flowInfo.receiveTime = dayjs(item.flowInfo.receiveTime).format('YYYY-MM-DD HH:mm:ss')
          return item
        })
        this.todoNum = res.totalCount
      }
    },
    async getDoneList() {
      const [err, res] = await columnTableSearchApi.getTodoColumnTableV(
        this.page.pageNo,
        this.page.pageSize,
        {
          title: this.formInline.title,
          isCompeleted: true,
        }
      )
      if (!err) {
        this.doneList = _.map(res.items, (item) => {
          item.creationTime = item.creationTime
            ? dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss')
            : ''
          item.flowInfo.receiveTime = dayjs(item.flowInfo.receiveTime).format('YYYY-MM-DD HH:mm:ss')
          return item
        })
        this.doneNum = res.totalCount
      }
    },
    async reset() {
      this.page = this.$options.data().page
      this.formInline.title = ''
      await this.searchList()
    },
    toDetail(row, mode) {
      this.$router.push({
        path: `${this.routerBase}/portal-management/information-publish/column-publish-detail`,
        query: {
          columnId: row.columnId,
          id: row.columnTableId,
          mode,
        },
      })
    },
    async clickTitle(row) {
      let apiRequest = []
      if (row.type === columnTextType) {
        apiRequest = await columnTableApi.getTextColumnTableDetail(row.columnTableId)
      }
      // 图文栏目详情
      if (row.type === columnImgTextType) {
        apiRequest = await columnTableApi.getImageColumnTableDetail(row.columnTableId)
      }
      // 视频栏目详情
      if (row.type === columnVideoType) {
        apiRequest = await columnTableApi.getVideoColumnTableDetail({ id: row.columnTableId })
      }
      if (apiRequest[1]?.externalLink) {
        window.open(apiRequest[1].externalLink)
        return
      }
      this.previewData = {
        ...row,
        id: row.columnTableId,
      }
      this.$refs.previewDialog.detailInfo = this.previewData
      this.previewDialogVisible = true
    },
    handleProcess(row) {
      this.flowTaskId = row.flowTaskId
      this.flowVisible = true
    },
    async tabClick() {
      await this.reset()
      if (this.activeTab === 'todo') {
        this.tableData = this.todoList
        this.page.pageTotal = this.todoNum
      } else {
        this.tableData = this.doneList
        this.page.pageTotal = this.doneNum
      }
    },
  },
  created() {
    this.getAll()
  },
}
</script>

<style lang="scss" scoped>
.flow-list {
  ::v-deep .el-tabs {
    .el-tabs__content {
      height: calc(100% - 55px);
    }
  }
}
</style>
